module.exports = __webpack_public_path__ + "static/media/virtual-walkthrough.7f21d871.svg";